import axios from 'axios';
import { getToken } from './authUtil';

const baseURL = process.env.NODE_ENV === 'production' ? '/api' : 'http://127.0.0.1:5000/order-ar/us-central1/app/api';

const axiosInstance = axios.create({
    baseURL: baseURL,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;
